<div *ngIf="showModal" class="modal-overlay" (click)="closeModal()">
  <div class="modal-card slide-up max-h-[80vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div>
        <h2>REDEEM</h2>
        <p class="modal-subtitle">{{ selectedGame || 'Game' }}</p>
      </div>
      <button (click)="closeModal()" class="close-btn">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Free spin info -->
    <div *ngIf="isFromFreeSpin" class="info-banner">
      <span class="font-semibold text-cyan-200">Info:</span>
      Score below 10 (from free play) will still be redeemed, but it won’t add to your wallet — it will be lost. Play
      more to reach the eligible score to redeem into wallet.
    </div>

    <!-- Retry banner -->
    <div *ngIf="requestId" class="retry-banner">
      <div class="flex-1 min-w-0">
        <p class="text-xs leading-relaxed">
          <span class="font-mono font-semibold break-all">Retry For {{ requestId }}</span>
          <span class="mx-2">•</span>
          If you're unable to Redeem score after 2-3 retry attempts, please contact our support team and provide this
          Request ID.
        </p>
      </div>
      <button type="button" (click)="CopyToClipBoard(requestId)" title="Copy Request ID">
        <fa-icon [icon]="copy"></fa-icon>
      </button>
    </div>

    <!-- Score display -->
    <div class="score-display">
      <div class="score-row">
        <span>Current Score</span>
        <span class="score-value">
          @if (isScoreLoading) {
          <span class="loading-dots">
            <span></span><span></span><span></span>
          </span>
          } @else {
          @if (currentScore === '' || currentScore === null || currentScore === undefined) {
          <fa-icon (click)="getScoreforAddding()" [icon]="refresh" class="refresh-icon"></fa-icon>
          } @else {
          <strong>{{ currentScore }}</strong>
          }
          }
          <fa-icon (click)="getScoreforAddding()" [icon]="refresh" class="refresh-icon"></fa-icon>
        </span>
      </div>
      <div class="score-row">
        <span>Eligible Score</span>
        <span class="score-value">{{ eligibleScore || '-' }} <span class="text-[10px] text-gray-500 font-normal">({{
            redeemMultiplier || '-' }} X) of Deposit</span></span>
      </div>
    </div>

    <!-- Info messages -->
    <div class="info-list">
      <div class="info-item purple">
        <div class="info-bar"></div>
        <p>Free Play Score is 10% Redeemable</p>
      </div>
      <div class="info-item amber">
        <div class="info-bar"></div>
        <div>
          <p>Max Redeem: {{ maxEligibleScre || '-' }} ({{maxRedeemX || '-'}}X of Add Score)</p>
          <span class="info-sub">${{ maxEligibleScre || '0' }} will be added to your Wallet</span>
        </div>
      </div>
      <div class="info-item teal">
        <div class="info-bar"></div>
        <div>
          <p>Redeem Eligible: {{ eligibleScore || '-' }}</p>
          <span class="info-sub">Full amount added to wallet. No deduction.</span>
        </div>
      </div>
      <div class="info-item orange">
        <div class="info-bar"></div>
        <div>
          <p>If Redeeming Less than {{ eligibleScore || '-' }}</p>
          <span class="info-sub">Bonus deducted, remaining added to wallet.</span>
        </div>
      </div>
    </div>

    <form [formGroup]="redeemForm" (click)="$event.stopPropagation()" class="modal-form">
      <!-- Game + Score -->
      <div class="form-row two-col">
        <div class="form-group">
          <label>Game</label>
          <div class="select-display" (click)="isFromRedeem ? (gameDropdownOpen = !gameDropdownOpen) : null"
            [class.cursor-not-allowed]="!isFromRedeem">
            <span>{{ selectedGame || 'Select game' }}</span>
            <i class="fas fa-chevron-down text-[10px]" *ngIf="isFromRedeem"></i>
          </div>
          <ul *ngIf="gameDropdownOpen" class="dropdown-list">
            <li *ngFor="let game of filteredGameDropdownData">
              <a (click)="selectGame(game.name, $event)">
                {{ game.name }}
              </a>
            </li>
          </ul>
        </div>

        <div class="form-group">
          <label>Score</label>
          <input type="number" [value]="currentScore" readonly class="cursor-not-allowed" />
          <div class="error-text">
            <ng-container
              *ngIf="redeemForm.get('score')?.hasError('required') && redeemForm.get('score')?.touched">Score is
              required.</ng-container>
            <ng-container *ngIf="redeemForm.get('score')?.hasError('min') && redeemForm.get('score')?.touched">Score
              must be greater than 0.</ng-container>
            <ng-container
              *ngIf="redeemForm.get('score')?.hasError('notInteger') && redeemForm.get('score')?.touched">Score must be
              an integer.</ng-container>
          </div>
        </div>
      </div>

      <!-- Withdraw fields -->
      <div *ngIf="selectedPaymentMethod === 'withdraw'" class="form-group relative">
        <label>Account Type</label>
        <div class="select-display" (click)="accountTypeDropdownOpen = !accountTypeDropdownOpen">
          <span>{{ accountType || 'Choose a Type' }}</span>
          <i class="fas fa-chevron-down text-[10px]"></i>
        </div>
        <ul *ngIf="accountTypeDropdownOpen" class="dropdown-list">
          <li *ngFor="let game of accountTypeData">
            <a (click)="onAccountTypeChange(game)">{{ game.name }}</a>
          </li>
        </ul>
      </div>

      <div class="form-group" *ngIf="isAccountTypeSelected">
        <label>Account Title</label>
        <input formControlName="accountInfo" [(ngModel)]="accountInfo" placeholder="Enter Title" />
      </div>

      <div class="form-group" *ngIf="accountType === 'Chime'">
        <label>Account Number/ Tag</label>
        <input formControlName="CustomerTag" [(ngModel)]="CustomerTag" placeholder="Enter Tag" />
      </div>

      <button type="button" class="btn-gold-modal" (click)="submitRedeem()">
        REDEEM <i class="fas fa-arrow-right"></i>
      </button>
    </form>
  </div>
</div>